// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__17d4x","tab":"ProcedureTabs_tab__34Tzp"};